import { Route, Outlet } from 'react-router-dom'

import Dashboard from './Dashboard'
import DetailProject from './DetailProject'

export const ProjectsRoutes = ({ path = '/projects' }) => [
  <Route path={path} element={<Outlet />} key="projects-layout">
    <Route path="" index key="projects" element={<Dashboard />} />
    <Route path=":id" index key="projects-id" element={<DetailProject />} />
  </Route>
]

export default ProjectsRoutes
